import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProgressReportDto } from '../../models/leap-v2-api.model';
import { LeapV2ProgressReportService } from '../../services/leap-v2-progress-report.service';

interface DialogData {
  placementId: number;
  studentId: number;
  studentName: string;
}

/**
 * Lists a learner's 6-week progress reports as lightweight tiles (newest first by CreatedDate),
 * each tagged Submitted / Approved. Closing with a report tells the caller which one to open.
 */
@Component({
  selector: 'progress-report-list-dialog',
  templateUrl: './progress-report-list-dialog.component.html',
  styleUrls: ['./progress-report-list-dialog.component.css'],
  standalone: false,
})
export class ProgressReportListDialogComponent implements OnInit {
  reports: ProgressReportDto[] = [];
  loading = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private dialogRef: MatDialogRef<ProgressReportListDialogComponent>,
    private progressReportService: LeapV2ProgressReportService
  ) { }

  ngOnInit(): void {
    this.progressReportService.listProgressReports(this.data.placementId, this.data.studentId)
      .subscribe(reports => {
        this.reports = [...reports].sort((a, b) => this.createdTime(b) - this.createdTime(a));
        this.loading = false;
      });
  }

  /** Status pill label by statusId: 1 Saved, 2 Submitted, 3 Approved, 4 Rejected. */
  statusLabel(statusId?: number): string {
    switch (statusId) {
      case 1: return 'Saved';
      case 2: return 'Submitted';
      case 3: return 'Approved';
      case 4: return 'Rejected';
      default: return '';
    }
  }

  /** Status pill colour class (defined in this component's css) matching statusLabel. */
  statusClass(statusId?: number): string {
    switch (statusId) {
      case 1: return 'pr-status--saved';
      case 2: return 'pr-status--submitted';
      case 3: return 'pr-status--approved';
      case 4: return 'pr-status--rejected';
      default: return '';
    }
  }

  select(report: ProgressReportDto): void {
    this.dialogRef.close(report);
  }

  close(): void {
    this.dialogRef.close();
  }

  private createdTime(report: ProgressReportDto): number {
    return report.createdDate ? new Date(report.createdDate).getTime() : 0;
  }
}
